export default "__VITE_ASSET__BLT3XE20__"